var GenericView = require('views/generic.view.ts');
var _ = require("underscore");
var Handlebars = require('handlebars');
var Template = require('text-loader!../../templates/consumption/yearly.consumption.template.html');

var FlexibilityTable = require('../flexibility_table.view.ts');

var TheView = GenericView.extend({
    el: '#yearly',
    tagName: '',
	template: Handlebars.compile(Template),
	fields: [],
	initialize: function (options) {
        this.render();
        GenericView.prototype.storeView(this, "yearly");
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);

        this.flexibility_table = new FlexibilityTable();
    },
    events: {
        "input .to-validation input": "validateIt",
        "click [data-toggle='toggle']": "showOrHideFlexibility"
    },
    validateIt: _.debounce(
        function(event)
        {
            var element = $(event.currentTarget);
            this.validateSingleField(element);
        },
    300),
    showOrHideFlexibility: function(event) {
        var toggle = $(event.currentTarget).find("input");

        if (!toggle.prop('checked')) {
            this.$el.find('.flexibility').show().removeClass('noValidation');
        } else {
            this.$el.find('.flexibility').hide().addClass('noValidation');
        }
    },
    getAllData: function() {
        var data = {
            "DMSactive": this.$el.find(".flexibility").css('display') !== 'none' ? true : false,
            "country": this.$el.find(".select-country").val(),
            "yearly": [this.$el.find("#yearly").val()],
            "consumption": "NotCustomized",
            "filename": null,
            "winter0": this.$el.find('tr[data-zone-type="Winter"]').find('input[data-time-of-usage="ZeroAMToEightAM"]').val() != "" ? parseInt(this.$el.find('tr[data-zone-type="Winter"]').find('input[data-time-of-usage="ZeroAMToEightAM"]').val()) : 0,
            "winter16": this.$el.find('tr[data-zone-type="Winter"]').find('input[data-time-of-usage="FourPMToTwelvePM"]').val() != "" ? parseInt(this.$el.find('tr[data-zone-type="Winter"]').find('input[data-time-of-usage="FourPMToTwelvePM"]').val()) : 0,
            "spring0": this.$el.find('tr[data-zone-type="Spring"]').find('input[data-time-of-usage="ZeroAMToEightAM"]').val() != "" ? parseInt(this.$el.find('tr[data-zone-type="Spring"]').find('input[data-time-of-usage="ZeroAMToEightAM"]').val()) : 0,
            "spring16": this.$el.find('tr[data-zone-type="Spring"]').find('input[data-time-of-usage="FourPMToTwelvePM"]').val() != "" ? parseInt(this.$el.find('tr[data-zone-type="Spring"]').find('input[data-time-of-usage="FourPMToTwelvePM"]').val()) : 0,
            "summer0": this.$el.find('tr[data-zone-type="Summer"]').find('input[data-time-of-usage="ZeroAMToEightAM"]').val() != "" ? parseInt(this.$el.find('tr[data-zone-type="Summer"]').find('input[data-time-of-usage="ZeroAMToEightAM"]').val()) : 0,
            "summer16": this.$el.find('tr[data-zone-type="Summer"]').find('input[data-time-of-usage="FourPMToTwelvePM"]').val() != "" ? parseInt(this.$el.find('tr[data-zone-type="Summer"]').find('input[data-time-of-usage="FourPMToTwelvePM"]').val()) : 0,
            "autumn0": this.$el.find('tr[data-zone-type="Autumn"]').find('input[data-time-of-usage="ZeroAMToEightAM"]').val() != "" ? parseInt(this.$el.find('tr[data-zone-type="Autumn"]').find('input[data-time-of-usage="ZeroAMToEightAM"]').val()) : 0,
            "autumn16": this.$el.find('tr[data-zone-type="Autumn"]').find('input[data-time-of-usage="FourPMToTwelvePM"]').val() != "" ? parseInt(this.$el.find('tr[data-zone-type="Autumn"]').find('input[data-time-of-usage="FourPMToTwelvePM"]').val()) : 0
        };

        return data;
    }
});

module.exports= TheView;